import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import { CgWebsite } from "react-icons/cg";
import { FaStar } from "react-icons/fa";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";

// Existing Assets
import chatgpts from '../../Assets/Projects/chat gpts.png';
import featureGrapfic from '../../Assets/Projects/feature graphic.png';
import ifahamu from "../../Assets/Projects/ifahamu image.png";
import onlinegrocery from "../../Assets/Projects/Online grocery.png";
import schoolapp from "../../Assets/Projects/school app.png";
import recipie from "../../Assets/Projects/image824.png";
import sgbms from '../../Assets/Projects/adm2.png';

import digistem from '../../Assets/Projects/image1.png';
import digistem_mobile from '../../Assets/Projects/digistem_mobile.png'
import digiskool from '../../Assets/Projects/digiskool_landing.png';
import digiskoolkids from '../../Assets/Projects/digikids.png';
import cashflowweb from '../../Assets/Projects/cashflowweb.png';
import cashflowImg from '../../Assets/Projects/cashflow.png';
import digiskoolMobile from '../../Assets/Projects/digiapp.png';
import arduinoBot from '../../Assets/Projects/nganya.png';
import delights from '../../Assets/Projects/delights.png';
import credence from '../../Assets/Projects/credence.png';
import fieldtrackImg from '../../Assets/Projects/Phone Feature Graphic.png';
import fieldtrackWeb from '../../Assets/Projects/fieldtrack_crm_web.png';

function Projects() {
  const [filter, setFilter] = useState('all');

  const projects = [
    // ======= NEW PROJECTS =======
    {
      "imgPath": fieldtrackImg,
      "type": "mobile",
      "title": "FieldTrack CRM Mobile App",
      "tags": ["Flutter", "React", "Mobile App", "CRM"],
      "description": "A powerful CRM mobile application designed for sales and marketing professionals. It features geographic movement tracking, automated fare calculation, and seamless reimbursement management during field operations.",
      "features": [
        "Real-time movement tracking for field agents",
        "Automated fare calculation and reimbursement request generation",
        "Client relationship management and lead tracking",
        "Offline-capable data entry with auto-sync"
      ],
      "demoLink": "https://play.google.com/store/apps/details?id=com.bigbrainzsolutions.fieldtrack_pro&hl=en",
      "stats": [
        { "value": "GPS", "label": "Movement Tracking" },
        { "value": "CRM", "label": "Sales Management" }
      ]
    },
    {
      "imgPath": fieldtrackWeb,
      "type": "web",
      "title": "FieldTrack CRM Admin Dashboard",
      "tags": ["React", "Admin Dashboard", "Analytics", "CRM"],
      "description": "The centralized web administrative dashboard for FieldTrack CRM. Administrators can monitor field agents' movements in real-time, process fare reimbursements, and analyze sales and marketing performance across various regions.",
      "features": [
        "Interactive analytics and reporting for sales teams",
        "Agent tracking and historical movement visualization",
        "Reimbursement approval workflows",
        "Comprehensive user and team management"
      ],
      "stats": [
        { "value": "Admin", "label": "Dashboard" },
        { "value": "Analytics", "label": "Reporting" }
      ]
    },

    {
      imgPath: digistem,
      type: "web",
      title: "DigiStem LMS",
      tags: ["React.js", "Firebase", "AI Integration"],
      description: "An AI-powered STEM learning Management System that automates Stem education process, lesson scheduling, lesson plan management and performance tracking. Trainers oversee AI-assisted workflows, ensuring data completeness and accuracy while reducing administrative workload.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://digi-stem.web.app/",
      stats: [
        { value: "AI", label: "Lesson Generator" },
        { value: "Realtime", label: "Data Insights" },
      ]
    },
    {
      imgPath: digiskool,
      type: "web",
      title: "DigiSkool ERP Landing Page",
      tags: ["React native", "Expo", "Firebase", "Landing Page", "School ERP"],
      description: "Marketing and information landing page for DigiSkool ERP - a comprehensive school management system. Showcases features for parents, teachers, and administrators including attendance tracking, performance analytics, announcements, and AI insights.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://digiskool.co.ke/",
      stats: [
        { value: "Landing", label: "Page" },
        { value: "Product", label: "Showcase" }
      ]
    },
    
    {
      "imgPath": cashflowweb,
      "type": "web",
      "title": "CashFlow Landing Page",
      "tags": ["React", "UI/UX Design", "Animations", "SEO", "Product Website"],
      "description": "Designed and developed the official CashFlow landing page — a visually engaging and conversion-focused product site. It introduces CashFlow as the ultimate financial companion, highlighting its features, testimonials, and security assurance with an elegant modern design and smooth animations.",
      "demoLink": "https://cash-flow.co.ke/",
      "stats": [
        { "value": "Landing", "label": "Page" },
        { "value": "Product", "label": "Showcase" }
      ]
    },
    {
      "imgPath": digiskoolkids,
      "type": "web",
      "title": "DigiSkool Kids – STEM Holiday Boot Camp",
      "tags": ["React", "Animations", "Education", "STEM", "Web Design"],
      "description": "A vibrant and interactive landing page for DigiSkool Kids, promoting the STEM Holiday Boot Camp. The site highlights key STEM programs, class categories, fun learning experiences, and registration options. Designed to engage parents and children alike through dynamic visuals, smooth animations, and a modern tech-inspired aesthetic.",
      "features": [
        "Engaging visuals and video banner for immersive storytelling",
        "Bright STEM-inspired color palette and animated sections",
        "Interactive sign-up and registration form",
        "Program highlights covering coding, robotics, science, and creativity",
        "Responsive and mobile-friendly design optimized for parents and guardians"
      ],
      "goals": "To inspire parents to enroll their children in the DigiSkool STEM Holiday Boot Camp and showcase the unique value of experiential, technology-driven learning.",
      
        "demoLink": "https://digiskoolkids.com/",
        "github": "https://github.com/Sheldon-codes/",
      
      "stats": [
        { "value": "1K+", "label": "Students Enrolled" },
        { "value": "20+", "label": "STEM Activities" },
        { "value": "100%", "label": "Parental Satisfaction" }
      ],
      "extra": {
        "landingPage": {
          "title": "DigiSkool Kids Website",
          "description": "Designed and developed a visually captivating landing page for DigiSkool Kids to promote their STEM Holiday Boot Camp. It combines animations, engaging imagery, and a playful theme to attract young learners and parents interested in tech education.",
          "link": "https://digiskool.co.ke/digikids"
        }
      }
    },

    {
      "imgPath": credence,
      "type": "web",
      "title": "Credence Movers – Moving & Relocation Website",
      "tags": ["React", "Next.js", "UI/UX Design", "Business Website", "SEO Optimized"],
      "description": "Credence Movers is a sleek, modern logistics and relocation website designed to help individuals and businesses move with confidence. The site highlights the company’s professionalism, transparency, and dedication to stress-free moving experiences through a visually appealing and highly responsive layout.",
      "features": [
        "Dynamic homepage with service highlights and client testimonials",
        "Smooth animations and elegant transitions for modern user experience",
        "Detailed service breakdown for residential, commercial, and international moves",
        "Responsive design for seamless browsing across mobile and desktop devices",
        "Integrated contact forms and quote request section for instant engagement",
        "Optimized for SEO and performance to enhance local business visibility"
      ],
      "goals": "To provide a strong digital presence for Credence Movers, building trust with potential clients while simplifying the process of discovering and booking professional moving services.",
      "demoLink": "https://credencemovers.co.ke/",
      "github": "https://github.com/Sheldon-codes/",
      
      "stats": [
        { "value": "1000+", "label": "Successful Moves" },
        { "value": "24/7", "label": "Customer Support" },
        { "value": "Nationwide", "label": "Service Coverage" }
      ],
      "extra": {
        "landingPage": {
          "title": "Credence Movers Official Website",
          "description": "Designed and developed a professional and conversion-focused landing page for Credence Movers. The website emphasizes reliability, customer satisfaction, and efficiency, helping clients easily book moving services and learn about the company’s full range of offerings.",
          "link": "https://credencemovers.co.ke/"
        }
      }
    },

    {
      "imgPath": delights,
      "type": "web",
      "title": "Delights Funeral Directors",
      "tags": ["React", "Next.js", "Web Design", "Funeral Services", "Responsive UI"],
      "description": "Delights Funeral Directors is a compassionate, modern, and informative landing page designed to support families during times of loss. The site provides clear information about funeral planning, repatriation, grief support, and memorial packages, all presented with a warm and respectful tone.",
      "features": [
        "Clean, calm, and elegant interface with soft, comforting visuals",

        "Detailed sections for services, packages, and contact information",
        "Integrated inquiry and support form for 24/7 assistance",
        "Smooth scroll animations and responsive design for all devices",
        "Trust-focused messaging with testimonials and accreditation highlights"
      ],
      "goals": "To provide a comforting and professional online presence for Delights Funeral Directors, helping families access information, plan services, and connect with the support they need.",
      
        "demoLink": "https://delightsfuneraldirectors.co.ke/",
        "github": "https://github.com/Sheldon-codes/",
      
      "stats": [
        { "value": "24/7", "label": "Support Availability" },
        { "value": "100+", "label": "Families Served" },
        { "value": "Nationwide", "label": "Service Coverage" }
      ],
      "extra": {
        "landingPage": {
          "title": "Delights Funeral Directors Website",
          "description": "Designed and developed a serene and trustworthy web presence for Delights Funeral Directors. The landing page emphasizes compassion, clarity, and accessibility, ensuring families can easily learn about available services and get in touch for immediate support.",
          "link": "https://delightsfuneraldirectors.co.ke/"
        }
      }
    },
    {
      "imgPath": digistem_mobile,
      "type": "mobile",
      "title": "DigiStem Instructor Mobile App",
      "tags": ["Flutter", "Firebase", "AI Automation", "Education", "Analytics"],
      "description": "The DigiStem Instructor Mobile App is a smart education companion built for teachers and trainers under the DigiSkool ecosystem. It streamlines lesson planning, attendance, student performance tracking, and AI-assisted academic insights, all within an intuitive, mobile-first experience.",
      "features": [
        "AI-assisted lesson plan automation with trainer approval workflow",
        "Real-time attendance tracking with GPS-based verification",
        "Instant student performance analytics and progress summaries",
        "Announcements, timetables, and assignment management",
        "Secure trainer login and role-based data access",
        "Offline mode with automatic cloud sync via Firebase"
      ],
      "goals": "To empower educators by simplifying daily teaching tasks, reducing manual reporting, and enabling data-driven decision-making across classrooms and institutions.",
      "links": {
        "demo": "https://digistem.co.ke/",
        "github": "https://github.com/Sheldon-codes/"
      },
      "stats": [
        { "value": "500+", "label": "Active Trainers" },
        { "value": "AI", "label": "Lesson Automation" },
        { "value": "Multi-school", "label": "Institution Support" }
      ],
      "extra": {
        "landingPage": {
          "title": "DigiStem Education Platform",
          "description": "Part of the DigiSkool ecosystem, DigiStem is an AI-driven platform designed to enhance STEM education through automation, analytics, and seamless trainer–student collaboration.",
          "link": "https://digistem.co.ke/"
        }
      }
    },
    {
      "imgPath": cashflowImg,
      "type": "mobile",
      "title": "CashFlow",
      "tags": ["Flutter", "Firebase", "AI Analytics", "Payments", "Finance"],
      "description": "CashFlow is a modern financial companion that empowers users to track expenses, pay bills, transfer money, and shop seamlessly—all in one secure app. Powered by SasaPay and regulated by the Central Bank of Kenya (CBK), CashFlow simplifies financial management for both individuals and businesses through real-time tracking, AI-driven insights, and multilingual support.",
      "ghLink": "https://github.com/Sheldon-codes/",
      "demoLink": "https://cash-flow.co.ke/",
      "stats": [
        { "value": "5K+", "label": "Active Users" },
        { "value": "AI-Powered", "label": "Financial Insights" },
        { "value": "24/7", "label": "Secure Transactions" }
      ],
    },
    {
      imgPath: digiskoolMobile,
      type: "mobile",
      title: "Digiskool Parents App",
      tags: ["React.js", "Firebase", "Geo-Fencing"],
      description: "A Parents App for Digiskool ERP - a comprehensive school management system. Parents can monitor their child's attendance, view attendance reports, and communicate with teachers and administrators through the app.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://digiskool.co.ke/",
      stats: [
        { value: "Parents", label: "Access" },
        { value: "Auto", label: "Realtime Updates" }
      ]
    },
    {
      imgPath: arduinoBot,
      type: "hardware",
      title: "Arduino Controlled Robot",
      tags: ["Arduino", "Sensor Shield V5.0", "IR Control"],
      description: "Smart robot built using Arduino with IR control via mobile phone. Integrated HX1838 receiver and I2C 1602 LCD for displaying system logs. Demonstrates IoT integration and embedded systems development.",
      ghLink: "https://github.com/Sheldon-codes/arduino-robot",
      demoLink: "https://github.com/Sheldon-codes/arduino-robot",
      stats: [
        { value: "IR", label: "Control System" },
        { value: "LCD", label: "Status Display" }
      ]
    },

    // ======= PREVIOUS PROJECTS =======

    {
      imgPath: featureGrapfic,
      type: "mobile",
      title: "TQC System",
      tags: ["Android", "Kotlin", "Firebase"],
      description: "Comprehensive training quality control system with intelligent class attendance tracking. Features real-time analytics and automated reporting for educational institutions.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://play.google.com/store/apps/details?id=sheldon.apps.tqcsystem",
      stats: [
        { value: "5K+", label: "Downloads" },
        { value: "4.5★", label: "Rating" }
      ]
    },
    {
      imgPath: chatgpts,
      type: "mobile",
      title: "ChatGPT_S",
      tags: ["Kotlin", "OpenAI", "Retrofit"],
      description: "AI-powered conversational assistant leveraging OpenAI's GPT models. Built with modern Android architecture featuring real-time responses and conversation history.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://github.com/Sheldon-codes/",
      stats: [
        { value: "95%", label: "Accuracy" },
        { value: "<2s", label: "Response" }
      ]
    },
    {
      imgPath: ifahamu,
      type: "mobile",
      title: "Ifahamu Kiswahili",
      tags: ["Kotlin", "Android", "Education"],
      description: "Educational platform for Kenyan secondary students. Offers comprehensive Kiswahili study materials, interactive quizzes, and gamified learning experiences.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://play.google.com/store/apps/details?id=sheldon.ifahamu.kiswahili",
      stats: [
        { value: "10K+", label: "Students" },
        { value: "500+", label: "Lessons" }
      ]
    },
    {
      imgPath: recipie,
      type: "mobile",
      title: "Recipe Haven",
      tags: ["Kotlin", "Multi-platform", "API"],
      description: "Global recipe discovery platform with user-generated content. Explore thousands of recipes and connect with food enthusiasts worldwide.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://github.com/Sheldon-codes/",
      stats: [
        { value: "2K+", label: "Recipes" },
        { value: "50+", label: "Countries" }
      ]
    },
    {
      imgPath: sgbms,
      type: "mobile",
      title: "Suggestion Box",
      tags: ["Kotlin", "Firebase", "Management"],
      description: "Streamlined feedback management system for educational institutions. Enables anonymous student suggestions with efficient tracking and response systems.",
      ghLink: "https://github.com/Sheldon-codes/online-grocery",
      demoLink: "https://online-grocery.web.app/",
      stats: [
        { value: "500+", label: "Submissions" },
        { value: "85%", label: "Resolved" }
      ]
    },
    {
      imgPath: onlinegrocery,
      type: "web",
      title: "Online Grocery",
      tags: ["React.js", "Firebase", "E-commerce"],
      description: "Modern e-commerce platform for local grocery shopping. Features real-time inventory, secure payments, and seamless delivery scheduling.",
      ghLink: "https://github.com/Sheldon-codes/online-grocery",
      demoLink: "https://online-grocery.web.app/",
      stats: [
        { value: "1K+", label: "Orders" },
        { value: "24/7", label: "Available" }
      ]
    },
    {
      imgPath: schoolapp,
      type: "web",
      title: "School Website",
      tags: ["React.js", "Firebase", "Material UI"],
      description: "Interactive college website with event management, announcements, and media galleries. Features comprehensive admin dashboard for content management.",
      ghLink: "https://github.com/Sheldon-codes/",
      demoLink: "https://plant49-ai.herokuapp.com/",
      stats: [
        { value: "5K+", label: "Visitors" },
        { value: "100+", label: "Events" }
      ]
    }
  ];

  const filteredProjects =
    filter === "all" ? projects : projects.filter((p) => p.type === filter);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        {/* Header Section */}
        <div className="project-header">
          <div className="project-badge">
            <FaStar className="badge-icon" />
            <span>Portfolio Showcase</span>
          </div>

          <h1 className="project-heading">
            Featured <strong className="purple">Projects</strong>
          </h1>

          <p className="project-subtitle">
            Crafting digital experiences that merge innovation with functionality
          </p>

          {/* Filter Buttons */}
          <div className="filter-buttons">
            <button
              className={`filter-btn ${filter === "all" ? "active" : ""}`}
              onClick={() => setFilter("all")}
            >
              All Projects
            </button>
            <button
              className={`filter-btn ${filter === "mobile" ? "active" : ""}`}
              onClick={() => setFilter("mobile")}
            >
              Mobile Apps
            </button>
            <button
              className={`filter-btn ${filter === "web" ? "active" : ""}`}
              onClick={() => setFilter("web")}
            >
              Web Apps
            </button>
            <button
              className={`filter-btn ${filter === "hardware" ? "active" : ""}`}
              onClick={() => setFilter("hardware")}
            >
              Hardware
            </button>
          </div>
        </div>

        {/* Projects Grid */}
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {filteredProjects.map((project, index) => (
            <ProjectCard key={index} project={project} index={index} />
          ))}
        </Row>

        {/* Coming Soon */}
        <div className="coming-soon-section">
          <div className="coming-soon-content">
            <CgWebsite className="coming-soon-icon" />
            <h3>More Projects Coming Soon</h3>
            <p>Currently crafting new experiences. Stay tuned for updates!</p>
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default Projects;
